import type * as lazyIndex from './lazyIndex';
import {
    LazyAction,
    LazyImport,
    LazyModule,
    registerLazyOrchestrator,
    createLazyComponent,
    type LazyComponent,
} from 'owa-bundling';
import { mountFullOptions } from 'owa-options-actions-shared/lib/actions/mountFullOptions';
import { openSharedMailboxSettings } from 'owa-account-config';
import type { DeepLinkOptionsFullProps } from './components/full/DeepLinkOptionsFull';
import type { ProjectionOptionsFullProps } from './components/full/ProjectionOptionsFull';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OptionsView"*/ './lazyIndex'),
    { name: 'OptionsView' }
);

export { OPTION_ROUTE_KEYWORD } from './optionRouteKeyword';

// Export delay loaded actions
export const lazyMountAndShowFullOptions: LazyAction<
    typeof lazyIndex.mountAndShowFullOptions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mountAndShowFullOptions);
export const lazyMountAndShowFullOptionsFromRoute: LazyAction<
    typeof lazyIndex.mountAndShowFullOptionsFromRoute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mountAndShowFullOptionsFromRoute);
export const lazyHandleFullOptionsDeepLink: LazyAction<
    typeof lazyIndex.handleFullOptionsDeepLink,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleFullOptionsDeepLink);
export const lazyHideFullOptions: LazyImport<typeof lazyIndex.hideFullOptions, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.hideFullOptions);
export const lazyConfirmDirtyOptionsAndPerformAction: LazyImport<
    typeof lazyIndex.confirmDirtyOptionsAndPerformAction,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.confirmDirtyOptionsAndPerformAction);

export const lazyExitOptionsFullPage: LazyImport<
    typeof lazyIndex.exitOptionsFullPage,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.exitOptionsFullPage);

export const lazyCloseOrMinimizeFullOptions: LazyAction<
    typeof lazyIndex.closeOrMinimizeFullOptions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.closeOrMinimizeFullOptions);

// Export delay loaded components
export const ProjectionOptionsFull: LazyComponent<ProjectionOptionsFullProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.ProjectionOptionsFull);
export const DeepLinkOptionsFull: LazyComponent<DeepLinkOptionsFullProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.DeepLinkOptionsFull);

// Register lazy orchestrator
registerLazyOrchestrator(mountFullOptions, lazyModule, m => m.mountFullOptionsOrchestrator);
registerLazyOrchestrator(
    openSharedMailboxSettings,
    lazyModule,
    m => m.openSharedMailboxSettingsOrchestrator
);
